// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        showDisplay: true,
        activeScrollToTop: true,
        //loadProductFirst: true,
        sortingList: ['manual', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending', 'published-descending', 'published-ascending', 'sale-descending']
    },
    label: {
        sorting: {
            'manual' : bcSfFilterConfig.label.sorting_featured, 
            'title-ascending': bcSfFilterConfig.label.sorting_title_ascending,
            'title-descending': bcSfFilterConfig.label.sorting_title_descending,
            'price-ascending' : bcSfFilterConfig.label.sorting_price_ascending, 
            'price-descending' : bcSfFilterConfig.label.sorting_price_descending,
            'published-descending': bcSfFilterConfig.label.sorting_date_ascending, 
            'published-ascending': bcSfFilterConfig.label.sorting_date_descending,
            'sale-descending': '% Off',
        }
    }
};

var bcSfFilterTemplate = {
    'fixedWidthClass': 'fixed-width',
    'hasThumbnailClass': 'has-thumbnails',
    'noSkuClass': 'sku--no-sku',
 
    'vendorHtml': '<p class="vendor">' + bcSfFilterConfig.label.vendor + ' <a href="{{itemVendorUrl}}">{{itemVendorLabel}}</a></p>',
    'skuHtml': '<div class="sku {{itemNoSkuClass}}">' + bcSfFilterConfig.label.sku + ' <span class="sku__value">{{itemFirstVariantSku}}</span></div>',

    'productGridItemHtml': '<div data-product-id="{{itemId}}" class="product-block detail-mode-' + bcSfFilterConfig.custom.hov_type + ' {{itemFixedWidthClass}}">' +
                                '<div class="block-inner">' +
                                    '<a class="product-link" href="{{itemUrl}}">' +
                                        '<div class="image-cont">' +
                                            '<div class="image-label-wrap">' +
                                                '<div class="reveal">' +
                                                    '<img src="{{itemThumbUrl}}" />' +
                                                    '{{itemFlipImage}}' +
                                                '</div>' +
                                                '{{itemLabel}}' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="product-info">' +
                                            '<div class="inner">' +
                                                '<div class="innerer">' +
                                                    '<div class="title">{{itemTitle}}</div>' +
                                                    '<div class="dash">-</div>' +
                                                    '{{itemPrice}}' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +

                                '<div class="product-detail">' +
                                    '<a href="#" class="close-detail">X</a>' +
                                        '<div class="container inner cf">' +
                                            '<div class="gallery layout-column-half-left {{itemHasThumbnailClass}}">' +
                                                '<div class="main-image">' +
                                                    '<a href="{{itemUrl}}">' +
                                                        '<img src="' + bcSfFilterConfig.custom.blank_image_url + '" data-src="{{itemThumbLargeUrl}}" alt="{{itemTitle}}"/>' +
                                                    '</a>' +
                                                '</div>' +
                                                '{{itemSlideshow}}' +
                                            '</div>' +
                                            '<div class="detail layout-column-half-right">' +
                                                '{{itemLabel}}' +
                                                '<h2 class="h1-style title"><a href="{{itemUrl}}">{{itemTitle}}</a></h2>' +
                                                '<h2 class="h4-style price-area">{{itemPriceDialog}}</h2>' +
                                                '{{itemVendor}}' +
                                                '{{itemSku}}' +

                                                '<div class="product-form section">{{itemAddToCart}}</div>' +
                                                // '<div class="description user-content">{{itemDescription}}</div>' + // truncate 150
                                                '<a class="more" href="{{itemUrl}}">' + bcSfFilterConfig.label.read_more + ' &rarr;</a>' +
                                            '</div>' +
                                        '<script>theme.productData[{{itemId}}] = {{itemProductJson}};</script>' +
                                    '</div>' +
                                '</div>' +
                            '</div>',

    'previousDisabledHtml': '<span class="prev">« Previous</span>',
    'previousActiveHtml': '<a class="next" href="{{itemUrl}}">« Previous</a>',
    'nextDisabledHtml': '<span class="next">Next »</span>',
    'nextActiveHtml': '<a class="next" href="{{itemUrl}}">Next »</a>',
    'paginateHtml': '{{previous}} <span class="pagecount">{{pageItems}}</span> {{next}}',
  
    'sortingHtml': '<label for="sort-by">' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>'
};

BCSfFilter.prototype.buildExtrasProductList = function(data) {
    theme.Sections.register('collection-template', theme.CollectionTemplateSection);
};
"undefined"==typeof freegifts_product_json&&(window.freegifts_product_json=function(a){if(a){for(var b=function(a){for(var b in a)if(a.hasOwnProperty(b))return!1;return!0},c=a.price,d=a.price_max,e=a.price_min,f=a.compare_at_price,g=a.compare_at_price_max,h=a.compare_at_price_min,i=0;i<a.variants.length;i++){var j=a.variants[i],k=j.option3?j.option3:j.option2?j.option2:j.option1;"undefined"!=typeof SECOMAPP&&"undefined"!=typeof SECOMAPP.gifts_list_avai&&!b(SECOMAPP.gifts_list_avai)&&"undefined"!=typeof SECOMAPP.gifts_list_avai[j.id]||k.endsWith("(Freegifts)")||k.endsWith("% off)")?(a.variants.splice(i,1),i-=1):(d>=j.price&&(d=j.price,c=j.price),e<=j.price&&(e=j.price),j.compare_at_price&&(g>=j.compare_at_price&&(g=j.compare_at_price,f=j.compare_at_price),h<=j.compare_at_price&&(h=j.compare_at_price)),1==j.available&&(a.available=!0))}a.price=c,a.price_max=e,a.price_min=d,a.compare_at_price=f,a.compare_at_price_max=h,a.compare_at_price_min=g,a.price_varies=e>d?!0:!1,a.compare_at_price_varies=h>g?!0:!1}return a});

BCSfFilter.prototype.buildProductGridItem = function(data) {
  data = freegifts_product_json(data);
  // Prepare data
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    var soldOut = !data.available;
    var onSale = data.compare_at_price_max > data.price_min;
    var priceVaries = data.price_varies && data.price_compare_at_min != data.price_compare_at_max;
    // Get First Variant
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') {
            firstVariant = paramVariant[0];
        }
    }

    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add label
    var itemLabelHtml = '';
    if (soldOut) {
        itemLabelHtml = '<span class="productlabel soldout"><span>' + bcSfFilterConfig.label.sold_out + '</span></span>';
    }
    if (onSale) {
        var savePrice = (data.compare_at_price_max - data.price_min) * 100 / data.compare_at_price_max;
        itemLabelHtml = '<span class="productlabel sale"><span>- ' + Math.floor(savePrice) + ' %</span></span>'
    } else if (bcSfFilterConfig.custom.prod_stock_warn_show && data.variants.length == 1 && firstVariant.inventory_management !== null && firstVariant.inventory_management.length > 0 && firstVariant.inventory_quantity > 0 && firstVariant.inventory_quantity < bcSfFilterConfig.custom.prod_stock_warn_limit) {
        itemLabelHtml = '<span class="productlabel general"><span>' + bcSfFilterConfig.label.only_x_left.replace(/{{ quantity }}/g, firstVariant.inventory_quantity) + '</span></span>';
    } else {
        if (data.tags) {
            for (var k = 0; k < data.tags.length; k ++) {
                if (data['tags'][k].indexOf('meta-label-') != -1) {
                    itemLabelHtml == '<span class="productlabel general"><span>' + data['tags'][k].replace('meta-label-', '') + '</span></span>';
                    break;
                }

            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Size on hover
    var itemSizeHtml = '';
    for (var k in data.variants) {
        if (data['variants'][k].hasOwnProperty('option_size')) {
            if (data['variants'][k]['available']) {
                itemSizeHtml += '<span class="sizeHover">' + data['variants'][k]['option_size'] + '</span>';
            } else {
                itemSizeHtml += '<span class="sizeHover gray">' + data['variants'][k]['option_size'] + '</span>';
            }
        } else if (data['variants'][k].hasOwnProperty('option_title')) {
            if (data['variants'][k]['available']) {
                itemSizeHtml += '<span class="sizeHover">' + data['variants'][k]['option_title'] + '</span>';
            } else {
                itemSizeHtml += '<span class="sizeHover gray">' + data['variants'][k]['option_title'] + '</span>';
            }
        } 
    }
    itemHtml = itemHtml.replace(/{{itemSize}}/g, itemSizeHtml);

    // Add class
    var itemFixedWidthClass = bcSfFilterConfig.custom.thumb_variable_width ? '' : bcSfFilterTemplate.fixedWidthClass;
    itemHtml = itemHtml.replace(/{{itemFixedWidthClass}}/g, itemFixedWidthClass);
    var itemHasThumbnailClass = data['images'].size > 1 ? bcSfFilterTemplate.hasThumbnailClass : '';
    itemHtml = itemHtml.replace(/{{itemHasThumbnailClass}}/g, itemHasThumbnailClass);

    // Add Thumbnail
    var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0], '480x') : bcSfFilterConfig.general.no_image_url;
    var itemThumbLargeUrl = images.length > 0 ? this.optimizeImage(images[0], '1024x1024') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    itemHtml = itemHtml.replace(/{{itemThumbLargeUrl}}/g, itemThumbLargeUrl);

    // Add Flip image
    var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]) : itemThumbUrl;
    var itemFlipImageHtml = '<img class="hidden" src="' + itemFlipImageUrl + '" alt="{{itemTitle}}" />';
    itemHtml = itemHtml.replace(/{{itemFlipImage}}/g, itemFlipImageHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.show_vendor ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor).replace(/{{itemVendorUrl}}/g, this.buildProductItemVendorUrl(data.vendor)) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Sku
    var itemNoSkuClass = data['variants'][0]['sku'] == '' ? bcSfFilterTemplate.noSkuClass : '';
    var itemSkuHtml = bcSfFilterConfig.custom.show_sku ? bcSfFilterTemplate.skuHtml.replace(/{{itemNoSkuClass}}/g, itemNoSkuClass).replace(/{{itemFirstVariantSku}}/g, firstVariant['sku']) : '';
    itemHtml = itemHtml.replace(/{{itemSku}}/g, itemSkuHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<div class="reducedfrom"><span class="amount">' + this.formatMoney(data.compare_at_price_max, this.moneyFormat) + '</span></div>';
    }
    itemPriceHtml += '<span class="price">';
    if (priceVaries) {
        itemPriceHtml += '<span class="from">' + bcSfFilterConfig.label.from_price + '</span>';
    }
    itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
    itemPriceHtml += '</span>';
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Description
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDescription = (itemDescription.split(" ")).length > 31 ? itemDescription.split(" ").splice(0, 31).join(" ") + '...' : itemDescription.split(" ").splice(0, 31).join(" ");
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add Quick view
    var itemQuickViewHtml = !soldOut && bcSfFilterConfig.custom.show_quick_shop ? (bcSfFilterTemplate.quickViewHtml).replace(/{{itemQuickViewUrl}}/g, this.buildProductItemUrl(data) + '?view=quick_shop') : '';
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // ------ Build Dialog ----- //
    // Add Json product data 
    itemHtml = itemHtml.replace(/{{itemProductJson}}/g, JSON.stringify(data));
    // Add Price
    var itemPriceDialogHtml = '';
    if (onSale) {
        itemPriceDialogHtml += '<span class="was-price">' + this.formatMoney(data.compare_at_price_max, this.moneyFormat) + '</span>';
    }
    itemPriceDialogHtml += '<span class="price">' + this.formatMoney(data['variants'][0]['price'], this.moneyFormat) + '</span>';
    itemHtml = itemHtml.replace(/{{itemPriceDialog}}/g, itemPriceDialogHtml);
    // Add Slideshow
    var itemSlideshowHtml = '';
    if (Object.keys(data['images']).length > 1) {
        itemSlideshowHtml = '<div class="thumbnails">' + bcSfFilterConfig.label.images;
        for (var k in data.images) {
            var activeClass = k == 1 ? 'class="active"' : '';
            itemSlideshowHtml += ' / <a ' + activeClass + 'href="' + this.optimizeImage(data['images'][k], '1024x1024') + '" data-full-size-url="' + this.optimizeImage(data['images'][k], 'master') + '"><span>' + k + '</span></a>';
        }
        itemSlideshowHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemSlideshow}}/g, itemSlideshowHtml);

    // Add Add to cart
    var itemAddToCartHtml = '';
    if (!soldOut) {
        itemAddToCartHtml += '<form class="form" action="/cart/add" method="post" enctype="multipart/form-data" data-product-id="{{itemId}}">';
      	itemAddToCartHtml += '<div class="bold_options"></div>';
        itemAddToCartHtml += '<div class="input-row">';
//         if (data['variants'].length > 1) {
//             itemAddToCartHtml += '<div class="option-selectors">';
//             for (var k in data.options_with_values) {
//                 itemAddToCartHtml += '<div class="selector-wrapper cf">';
//                 var optionClass = data['options_with_values'][k]['name'] == 'class="default"' ? 'hidden' : '';
//                 itemAddToCartHtml += '<label ' + optionClass + ' for="option-' + k + '">' + data['options_with_values'][k]['name'] + '</label>';
//                 itemAddToCartHtml += '<select id="option-' + k + '">';
//                 for (var i in data['options_with_values'][k]['values']) {
//                     var selected = i == 0 ? 'selected="selected"' : '';
//                     itemAddToCartHtml += '<option value="' + data['options_with_values'][k]['values'][i]['title'] + '" ' + selected + '>' + data['options_with_values'][k]['values'][i]['title'] + '</option>';
//                 }
//                 itemAddToCartHtml += '</select>';
//                 itemAddToCartHtml += '</div>';
//             }
//             itemAddToCartHtml += '</div>';

//             itemAddToCartHtml += '<select name="id" class="original-selector">';
//             for (var k in data.variants) {
//                 var selected = data['variants'][k]['id'] == firstVariant['id'] ? 'selected="selected"' : '';
//                 itemAddToCartHtml += '<option value="' + data['variants'][k]['id'] + '" ' + selected + ' >' + data['variants'][k]['title'] + '</option>'
//             }
//             itemAddToCartHtml += '</select>';
//         } else {
            itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant['id'] + '" />';
//             if (data['variants'][0]['title'] !== 'Default') {
//                 itemAddToCartHtml += '<label class="singleopt">';
//                 for (var option in data['variants'][0]) {
//                     if (option.indexOf('option_') !== -1) {
//                         itemAddToCartHtml += option.replace('option_', '') + ': ' + data['variants'][0][option] + '<br/>';
//                     }
//                 }
//                 itemAddToCartHtml += '</label>';
//             }
//         }
        itemAddToCartHtml += '</div>';
        itemAddToCartHtml += '<div class="input-row quantity-submit-row">';
        itemAddToCartHtml += '<input id="quantity" class="select-on-focus" name="quantity" value="1" size="2" />';
        itemAddToCartHtml += '<input type="submit" value="' + bcSfFilterConfig.label.add_to_cart + '" />';
        itemAddToCartHtml += '</div>';
        if (data['variants'].length == 1) {
            // {% if product.variants.first.inventory_management == 'shopify' and product.variants.first.inventory_quantity < 1 %}
            // <div class="backorder">
            //   <p><span class="selected-variant">{{ product.title }}</span> {{ 'products.product.backorder' | t }}</p>
            // </div>
            // {% endif %}
        } else {
            itemAddToCartHtml += '<div class="backorder hidden">';
            itemAddToCartHtml += '<p><span class="selected-variant"></span> ' + bcSfFilterConfig.label.backorder + '</p>';
            itemAddToCartHtml += '</div>'
        }
        itemAddToCartHtml += '</form>';
    }
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Build page items
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, 'Page ' + currentPage + ' of ' + totalPage);
        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Customize data to suit the theme
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        for (var i in data[k]['variants']) {
            var optionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            for (var j in variant) {
                if (j.indexOf('option_') != -1) {
                    data[k]['variants'][i]['option' + count] = data[k]['variants'][i][j];
                    optionArr.push(data[k]['variants'][i][j]);
                    count ++;
                }
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
            data[k]['variants'][i]['options'] = optionArr;
        }
    }
    return data;
};

function BCSfFilterCallback (result) {
	bcsffilter.hideLoading();
	bcsffilter.afterGetFilterData(result, result.event_type);
};

// Request API for Filter Data
BCSfFilter.prototype.getFilterData = function (eventType) {
	var _this = this;
	_this.showLoading();
	
	// Prepare params
	var params = mergeObject({}, this.queryParams);
	params.collection_scope = parseInt(this.collectionId);
	if (eventType == "history") {
		if (History.getState().data.hasOwnProperty("param") && History.getState().data.param.hasOwnProperty("collection_scope")) {
			params.collection_scope = this.collectionId = parseInt(History.getState().data.param.collection_scope);
		} else {
			params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
		}
	}
	if (this.getSettingValue("general.availableAfterFiltering") == true) {
		params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
		params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
	} else {
		params.product_available = this.productAvailable;
		params.variant_available = this.variantAvailable;
	}
	if (typeof this.collectionTags !== "undefined" && this.collectionTags !== null) {
		params.tag = this.collectionTags[0];
	}
	params.build_filter_tree = (typeof eventType !== "undefined" && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
	params.check_cache = (this.checkExistFilterOptionParam() === false && params["page"] == 1 && params["sort"] == this.defaultSorting && params["limit"] == this.getSettingValue("general.limit")) ? true : false; // Only cache when request doest not have Refine By, "page" param equal to 1 and "sort" param equal to default sorting
	// Set data back to queryParams
	this.queryParams = params;

	this.queryParams["callback"] = "BCSfFilterCallback";
	this.queryParams["event_type"] = eventType;
	var script = document.createElement("script");
	//Set the Type
	script.type = "text/javascript";
	var timestamp = new Date().getTime();
	//Set the source to the URL the JSON Service.
	script.src = bcSfFilterConfig.shop.apiUrl + "?t=" + timestamp + "&" + jQ.param(_this.queryParams);
	script.async = true;
	script.addEventListener("error", function (e) {
		this.remove();
		// Error handling here 
		_this.showError("Oops, we cannot fetch products at this moment. Please try again later.");
	});
	//Append the script element to the HEAD section.
	document.getElementsByTagName("head")[0].appendChild(script);
	script.onload = function () {
		this.remove();
	};
};

// Customize data to suit the theme
BCSfFilter.prototype.prepareProductData = function(data) {
	for (var k in data) {
		var optionsArr = [];
		for (var i in data[k]["options_with_values"]) {
			optionsArr.push(data[k]["options_with_values"][i]["name"]);
		}
		data[k]["options"] = optionsArr;
		for (var i in data[k]["variants"]) {
			var variantOptionArr = [];
			var count = 1;
			var variant = data[k]["variants"][i];

		   // New API
			if (typeof variant.hasOwnProperty("merged_options")) {
				var variantOptions = variant["merged_options"];
				for (var j in variantOptions) {
				  var temp = variantOptions[j].split(":");
				  data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
				  data[k]["variants"][i]["option_" + temp[0]] = temp[1];
				  variantOptionArr.push(temp[1]);
				}
			}
			// Old API
			else {
				for (var j in variant) {
					if (j.indexOf("option_") != -1) {
					  data[k]["variants"][i]["option" + count] = variant[j];
					  variantOptionArr.push(data[k]["variants"][i][j]);
					  count ++;
					}
				}
			}
			data[k]["variants"][i]["compare_at_price"] = parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
			data[k]["variants"][i]["price"] = parseFloat(data[k]["variants"][i]["price"]) * 100;
			data[k]["variants"][i]["options"] = variantOptionArr;
		}
	}
	return data;
};

function mergeObject(a, b) {
	for (var c in b) try {
		a[c] = b[c].constructor == Object ? mergeObject(a[c], b[c]) : b[c]
	} catch (d) {
		a[c] = b[c]
	}
	return a
}

BCSfFilter.prototype.afterGetFilterData = function(a, b) {
		a.hasOwnProperty("errorMessage") ? this.showError("Oops, we cannot fetch products at this moment. Please try again later.") : (a.total_product <= 0 && ("page" == b && "default" != this.getSettingValue("general.paginationType") || (this.hasFilterOptionParam === !1 ? jQ(this.selector.filterWrapper).length > 0 && (jQ(this.selector.topNotification).length > 0 ? jQ(this.selector.topNotification).html("<p>Sorry, there are no products in this collection. Please select other collection or go back to homepage.</p>") : jQ(this.selector.filterWrapper).before('<div id="' + this.selector.topNotification + '"><p>Sorry, there are no products in this collection. Please select other collection or go back to homepage.</p></div>'), jQ(this.selector.filterWrapper).hide(), jQ(this.selector.filterTree).html(""), jQ(this.selector.filterTreeMobileButton).html(""), jQ(this.getSelector("products")).html("")) : jQ(this.getSelector("products")).html("<p>Sorry, no products matched your selection.</p>"), jQ(this.selector.bottomPagination).html(""), jQ(this.selector.topShowLimit).html(""), jQ(this.selector.topSorting).html(""))), this.buildAll(a, this.queryParams.build_filter_tree, b))
}
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
